<template>
  <b-card :title="title">
    <b-table :items="items" :fields="fields" responsive small show-empty empty-text="Aucun dossier à afficher.">
      <template #cell(code)="data">
        <b-link v-if="$can(project ? 'read_project' : 'read_bid', project ? 'Projets' : 'Offres')"
                :to="{name: project ? 'projects-view' : 'bids-view', params: {id: data.item.uid}}">
          {{ data.item.code }}
        </b-link>
        <span v-else>{{ data.item.code }}</span>
      </template>
      <template #cell(date)="data">{{ formatDate(data.item.date) }}</template>
    </b-table>
    <slot />
  </b-card>
</template>
<script>
import {BCard, BTable, BLink} from 'bootstrap-vue';
export default {
  components: {BCard, BTable, BLink},
  props: {
    title: {type: String, required: true},
    items: {type: Array, required: true},
    project: {type: Boolean, default: false},
  },
  data: () => ({fields: [
    {key: 'code', label: 'Référence'}, {key: 'customer_name', label: 'Client'}, {key: 'date', label: 'Date'},
  ]}),
  methods: {
    formatDate(value) { return value ? new Date(value).toLocaleDateString('fr-FR') : this.project ? 'Date de gain inconnue' : 'Date de création inconnue'; },
  },
};
</script>
